import React from "react";

export default function LoadingScreen() {
  return (
    <>
      <div className="loadinScren d-flex justify-content-center align-items-center">
        <i className="fa-solid fa-spinner fa-spin fa-7x text-white"></i>
      </div>
    </>
  );
}
